module.exports = __webpack_public_path__ + "img/img-126.ae36d7d2.png";